// extracted by mini-css-extract-plugin
module.exports = {"order":"order_info_order__3h7Xa","orderNum":"order_info_orderNum__cY8rg","menu":"order_info_menu__2GeeC","count":"order_info_count__1p1Ol","price":"order_info_price__yfiEF"};